<script setup lang="ts">

</script>

<template>
  <div class="grid grid-cols-2 gap-4">
    <app-button :to="{name: 'select pulsa'}">
      <img
        src="@/assets/images/icon-pulsa.svg"
        alt="Menu Icon Pulsa">
      PULSA
    </app-button>
    <app-button :to="{name: 'select internet'}">
      <img
        src="@/assets/images/icon-paketdata.svg"
        alt="Menu Icon Paket Data">
      PAKET
    </app-button>
    <app-button :to="{name: 'select pln'}">
      <img
        src="@/assets/images/icon-token.svg"
        alt="Menu Icon Token PLN">
      TOKEN
    </app-button>
  </div>
</template>

<style scoped>
@reference "@/assets/styles/main.css";

button,
a {
  @apply flex justify-center flex-col items-center gap-2;
  @apply h-40 rounded-md p-5;
  @apply bg-primary-50 border border-primary-300;
  @apply text-primary-800 font-bold text-sm tracking-wide;
}
</style>
